<template>
    <div class="splash-container__block splash-container__block_logo">
        <div class="splash-load">
            <loader />
        </div>
    </div>
</template>
